(() => {
  const purchaseButtonSelector = [
    'button[id^="ProductSubmitButton-"]',
    'form[action*="/cart/add"] button[name="add"]',
    'form[action*="/cart/add"] button[type="submit"]'
  ].join(', ');

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-dt-scroll-purchase]');

    if (!button) return;

    const purchaseButton = document.querySelector(purchaseButtonSelector);

    if (!purchaseButton) return;

    const purchasePanel =
      purchaseButton.closest('.product__info-container, .product__info-wrapper') ||
      purchaseButton;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    purchasePanel.scrollIntoView({
      behavior: reducedMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  });
})();
